import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-normal" }, "*", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("recoverPassword")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$t("newPassword")) + " ", 1),
        _hoisted_6
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        name: "password",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.passwordError ? _ctx.$t(_ctx.passwordError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.$t("confirmNewPassword")) + " ", 1),
        _hoisted_11
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        name: "confirmPassword",
        class: "form-control form-control-solid",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
        autocomplete: "off"
      }, null, 512), [
        [_vModelText, _ctx.confirmPassword]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.confirmPasswordError ? _ctx.$t(_ctx.confirmPasswordError) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetPassword())),
        class: "btn btn-lg btn-primary w-100 mb-5"
      }, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("resetBtn")), 1)
      ])
    ])
  ]))
}